import { apiNameToTrialIds, upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
import TrialActivationButton from '../_core/trial/activation/TrialActivationButton';
import { TRIAL_STANDARD_DURATION } from '../_core/trial/constants';
import { useMultiTrialTrackingProps } from '../_core/trial/useMultiTrialTrackingProps';
import Raven from 'raven-js';
import { useCallback, useMemo } from 'react';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { sourceKeys } from '../_core/common/data/upgradeData/properties/sources';
import { getSource } from '../_core/common/data/upgradeData/transformers/getPropertySource';
import { trackFailedApiNameMap } from '../_core/utils/metricUtils';
import { mapPurchaseMotionApiName } from '../ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const updateUpgradeData = upgradeData => {
  const {
    app,
    screen,
    uniqueId,
    duration
  } = upgradeData;
  const isScreenUrlPath = screen.split('/').length > 1;
  const source = isScreenUrlPath ? uniqueId // Special case for UMS modals (uniqueId === upgradeKey)
  : getSource({
    app,
    screen,
    uniqueId
  }, sourceKeys.TRIAL_BUTTON);
  return Object.assign({}, upgradeData, {
    apiName: mapPurchaseMotionApiName(true, upgradeData.upgradeProduct, 'UITrialActivationButton', upgradeData.apiName),
    source,
    trialId: upgradeProductToTrialIds[upgradeData.upgradeProduct] || null,
    duration: duration || TRIAL_STANDARD_DURATION
  });
};
const UITrialActivationButton = props => {
  const {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    isLoadingTrackingProps
  } = useMultiTrialTrackingProps();
  const upgradeData = updateUpgradeData(props.upgradeData);
  const apiName = upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  const getTrialId = useCallback(() => {
    if (apiName) {
      const trialIdFromApiName = apiNameToTrialIds[apiName];
      if (trialIdFromApiName) {
        return trialIdFromApiName;
      }
    }
    trackFailedApiNameMap('getTrialId', apiName || 'no api name', upgradeData.upgradeProduct);
    Raven.captureException(new Error(`failed to get trial id from apiName ${apiName} in getTrialId`));
    const trialIdFromUpgradeProduct = UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
    return trialIdFromUpgradeProduct;
  }, [apiName, upgradeData.upgradeProduct]);
  const upgradeDataWithTrialId = useMemo(() => {
    return Object.assign({}, upgradeData, {
      trialId: getTrialId()
    });
  }, [upgradeData, getTrialId]);
  return /*#__PURE__*/_jsx(TrialActivationButton, {
    upgradeData: upgradeDataWithTrialId,
    block: props.block,
    activeTrials: activeTrials,
    expiredTrials: expiredTrials,
    isMultiTrial: isMultiTrial,
    isLoadingTrackingProps: isLoadingTrackingProps,
    use: props.use,
    onClick: props.onClick,
    level: props.level,
    isUpgradePoint: props.isUpgradePoint,
    dataSeleniumId: props['data-selenium-id'],
    onSuccess: props.onSuccess,
    onTrialStartSuccess: props.onTrialStartSuccess,
    children: props.children
  });
};
export default UITrialActivationButton;